<script lang="ts">
    import { onDestroy } from "svelte";
import Alert from "../components/alert/Alert.svelte";
import Button from "../components/buttons/Button.svelte";
import TextInput from "../components/form/input/TextInput.svelte";

    import Paper from "../components/paper/Paper.svelte";
    import LinearProgress from "../components/progress/LinearProgress.svelte";
    import type { User } from "./userStore";
    import { userStore } from "./userStore";
    let password = "";
    let email = "";
    let group = "afa";
    let user: User;
    const unsubscribeUser = userStore.subscribe((v) => {
        user = v;
    });
    onDestroy(unsubscribeUser);
</script>

<div class="LoginPageContainer">
    <div class="LoginPage">
        {#if user.loggingIn}
            <div class="LoggingIn">
                <LinearProgress color="primary" />
            </div>
        {/if}

        <Paper>
            <h1>Login</h1>
            <form
                on:submit|preventDefault={() => {
                    userStore.login(email, password, group);
                }}
            >
                <TextInput type="text" value={group} label="Group" onchange={(value) => {group = value;}} />
                <TextInput type="email" value={email} label="E-Mail" onchange={(value) => {email = value;}} />
                <TextInput type="password" value={password} label="Password" onchange={(value) => {password = value;}} />
                <Button type="submit" label="Login" color="primary" elevation="elevation-1"/>
            </form>
        </Paper>
        {#if user.error}
            <Alert type="error" message={user.error}/>
        {/if}
    </div>
</div>

<style type="text/scss">
    h1 {
        font-size: 1.5rem;
        line-height: 1.5rem;
        margin: 0 0 1.5rem 0;
    }
    .LoginPageContainer {
        :global(.form-item) {
            margin-bottom: 20px;
        }
        display: flex;
        justify-content: center;
        min-height: 100vh;
        min-width: 100vw;
        padding-top: 200px;
    }
    .LoginPage {
        width: 400px;
        position: relative;
    }
    .LoggingIn {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }
</style>
